<template>
    <component :is="getComponent()"
        :global="global"
        :campaign="campaign" />
</template>

<script setup>
import App from './app.vue';
import Test from './test.vue';

const props = defineProps({
    global: {
        type: Object,
        required: true,
    },
    campaign: {
        type: Object,
        required: true,
    },
});

const getComponent = () => {
    return props.global.is_test ? Test : App;
};
</script>
